var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "card height"
  }, [_c('p', {
    staticClass: "text-black text-center mx-3 my-2"
  }, [_vm._v("Category")])]), _c('div', {
    staticClass: "card category"
  }, _vm._l(_vm.allCategories, function (category, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-3 mx-3"
    }, [_c('p', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `my-collapse-${index}`,
        expression: "`my-collapse-${index}`"
      }],
      staticClass: "category-list d-flex justify-content-between"
    }, [_vm.findCategory(category) ? _c('router-link', {
      attrs: {
        "to": _vm.routePath
      }
    }, [_vm._v(_vm._s(category.catalogLabel.en))]) : _vm._e(), _c('span', {
      staticClass: "when-open"
    }, [_c('b-icon-chevron-down')], 1), _c('span', {
      staticClass: "when-closed"
    }, [_c('b-icon-chevron-right')], 1)], 1), category.catalogLabel.en === 'Order Medicine?' ? _c('b-collapse', {
      attrs: {
        "id": `my-collapse-${index}`,
        "visible": "",
        "appear": ""
      }
    }, [_c('div', {
      staticClass: "ml-4 sub-category-list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'health-care',
          params: {
            market: _vm.marketList[6].name,
            marketid: _vm.marketList[6]._id,
            categoryid: category._id
          }
        }
      }
    }, [_vm._v("Search specific item")]), _c('router-link', {
      attrs: {
        "to": {
          name: 'order-prescription',
          params: {
            market: _vm.marketList[6].name,
            marketid: _vm.marketList[6]._id,
            categoryid: category._id
          }
        },
        "exact": ""
      }
    }, [_vm._v("Order with prescription")]), _c('router-link', {
      attrs: {
        "to": {
          name: 'pharmacy-Shop',
          params: {
            market: _vm.marketList[6].name,
            marketid: _vm.marketList[6]._id,
            categoryid: category._id
          }
        },
        "exact": ""
      }
    }, [_vm._v("Go to Pharmacy Shop")])], 1)]) : _vm._e(), category.catalogLabel.en === 'Book A Test?' ? _c('b-collapse', {
      attrs: {
        "id": `my-collapse-${index}`
      }
    }, [_c('div', {
      staticClass: "ml-4 sub-category-list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'package-test',
          params: {
            market: _vm.marketList[6].name,
            marketid: _vm.marketList[6]._id
          }
        }
      }
    }, [_vm._v("Package Tests")]), _c('router-link', {
      attrs: {
        "to": {
          name: 'diagnostic-centers',
          params: {
            market: _vm.marketList[6].name,
            marketid: _vm.marketList[6]._id
          }
        }
      }
    }, [_vm._v("Diagnostic Centers")]), _c('button', [_vm._v("Looking For Specific Test")])], 1)]) : _vm._e()], 1);
  }), 0)]), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }